import { Card, CardContent } from "../ui/card";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { CheckCircle, MessageCircle, Star, User } from "lucide-react";

export const ReviewForm = ({ register, formValues }) => (
  <>
    {/* Customer & Move Details */}
    <Card className="border-2 border-amber-400">
      <div className="bg-amber-500 px-3 py-2">
        <h3 className="font-bold text-white flex items-center gap-2 text-sm">
          <User className="h-4 w-4" />
          Customer & Move Details
        </h3>
      </div>
      <CardContent className="p-3 space-y-3">
        <div>
          <Label className="text-xs font-semibold">Customer Name</Label>
          <Input {...register("customer_name")} placeholder="John Smith" className="h-9 mt-1" />
        </div>
        <div className="grid grid-cols-2 gap-2">
          <div>
            <Label className="text-xs">From Postcode</Label>
            <Input {...register("moving_from")} placeholder="MK11 4BB" className="h-9 mt-1" />
          </div>
          <div>
            <Label className="text-xs">To Postcode (New Home)</Label>
            <Input {...register("moving_to")} placeholder="MK14 7BB" className="h-9 mt-1" />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <div>
            <Label className="text-xs">Move Date</Label>
            <Input {...register("moving_date")} placeholder="15th March 2026" className="h-9 mt-1" />
          </div>
          <div>
            <Label className="text-xs">Reference</Label>
            <Input {...register("quotation_reference")} placeholder="HG-00001" className="h-9 mt-1" />
          </div>
        </div>
      </CardContent>
    </Card>

    {/* Review Links */}
    <Card className="border-2 border-yellow-400 bg-yellow-50" data-testid="review-links-section">
      <div className="bg-gradient-to-r from-yellow-500 to-amber-500 px-3 py-2">
        <h3 className="font-bold text-white flex items-center gap-2 text-sm">
          <Star className="h-4 w-4" />
          Review Links
        </h3>
      </div>
      <CardContent className="p-3 space-y-3">
        <p className="text-xs text-amber-700">Paste your review links below - buttons will appear in the email when links are added</p>
        
        <div>
          <Label className="text-xs font-semibold flex items-center gap-2">
            <span className="w-5 h-5 bg-blue-500 rounded-full inline-flex items-center justify-center text-white text-xs">G</span>
            Google Review Link
          </Label>
          <Input 
            {...register("review_google_link")} 
            placeholder="https://g.page/r/your-google-review-link" 
            className="h-9 mt-1" 
          />
          {formValues.review_google_link && (
            <p className="text-xs text-green-600 mt-1 flex items-center gap-1">
              <CheckCircle className="h-3 w-3" /> Google Review button will appear
            </p>
          )}
        </div>

        <div>
          <Label className="text-xs font-semibold flex items-center gap-2">
            <span className="w-5 h-5 bg-green-500 rounded-full inline-flex items-center justify-center text-white text-xs">T</span>
            Trustpilot Review Link
          </Label>
          <Input 
            {...register("review_trustpilot_link")} 
            placeholder="https://www.trustpilot.com/review/your-company" 
            className="h-9 mt-1" 
          />
          {formValues.review_trustpilot_link && (
            <p className="text-xs text-green-600 mt-1 flex items-center gap-1">
              <CheckCircle className="h-3 w-3" /> Trustpilot button will appear
            </p>
          )}
        </div>
      </CardContent>
    </Card>

    {/* Custom Message */}
    <Card className="border-2 border-purple-300">
      <div className="bg-purple-500 px-3 py-2">
        <h3 className="font-bold text-white flex items-center gap-2 text-sm">
          <MessageCircle className="h-4 w-4" />
          Personal Message (Optional)
        </h3>
      </div>
      <CardContent className="p-3">
        <Textarea 
          {...register("review_custom_message")} 
          placeholder="Add a personal touch to your message... e.g., 'We hope you and the family are settling in nicely!'"
          className="min-h-[80px] text-sm"
        />
        <p className="text-xs text-gray-500 mt-1">Leave empty for default warm message</p>
      </CardContent>
    </Card>
  </>
);
